import React, { useImperativeHandle, useRef, useEffect, forwardRef, useState } from "react";
import { Modal } from 'bootstrap';
import Loader from "../../../components/ui/Loader/Loader";
import InputAssetSearch from "../../includes/ui/InputAssetSearch";
import HttpAPICall from "../../../services/HttpAPICall";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import NewInputGroupSearch from "../../includes/ui/NewInputGroupSearch";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import TapIcon from "../../../services/TapIcon";

const AssetLinkingWithDevice = forwardRef(({ detailData, onLinkSuccess }, ref) => {
    const [searchedAssetData, setSearchedAssetData] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [submitLoading, setSubmitLoading] = useState(false);

    const [formData, setFormData] = useState({
        master_id: "",
        asset_id: "",
        device_id: "",
        'hour_applicable': "",
        'odo_meter_applicable': "",
        'movable': "",
    });

    const access_token = useSelector(state => state.auth.access_token);

    const modalElem = useRef(null);
    const searchModal = useRef(null);

    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            searchModal.current.show();
            setFormData({
                device_id: detailData.id
            })
        }
    }));

    useEffect(() => {
        modalElem.current = document.getElementById("deviceLinkAssetID");
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        }
    }, []);
    const searchModalClose = () => {
        searchModal.current && searchModal.current.hide();
        resetForm()
    };
    const resetForm = () => {
        setSelectedGroup(null);
        setSearchedAssetData([]);
        setFormData({
            master_id: "",
            asset_id: "",
            device_id: "",
            'hour_applicable': "",
            'odo_meter_applicable': "",
            'movable': "",
        });
    };

    const onGroupChange = (selectedOption) => {
        setSelectedGroup(selectedOption);
        setSearchedAssetData([]);
        setFormData(prev => ({
            ...prev,
            master_id: selectedOption?.value || ""
        }));
    };
    const onAssetChange = (selectedOption) => {
        setSearchedAssetData(selectedOption);
        setFormData(prev => ({
            ...prev,
            asset_id: selectedOption?.value || "",
            hour_applicable: "",
            odo_meter_applicable: "",
            movable: "",
        }));
    };

    const submitData = (e) => {
        e.preventDefault();
        const payload = {
            master_id: formData.master_id,
            asset_id: formData.asset_id,
            device_id: formData.device_id,
            'hour_applicable': formData.hour_applicable,
            'odo_meter_applicable': formData.odo_meter_applicable,
            'movable': formData.movable,
        };
        setSubmitLoading(true);
        HttpAPICall.withAthorization("POST", BACKOFFICE_BASE_URL + "/device_asset_linking", access_token,
            {}, payload, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                searchModalClose();
                onLinkSuccess && onLinkSuccess(formData.device_id);
            }
        ).then(() => setSubmitLoading(false));
    };
    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    return (
        <>
            <div className="modal fade" id={"deviceLinkAssetID"} tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="devicelinkingAssetModalLabel">Device Linking With Asset</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form id="deviceLinkingForm" onSubmit={submitData}>

                                <div className="modal-body">
                                    <div className="row align-items-center py-2  justify-content-center">
                                        <label className="col-sm-3 form-label require">Group</label>
                                        <div className="col-sm-8">
                                            <NewInputGroupSearch
                                                placeholder="Search Group"
                                                changeEvent={onGroupChange}
                                                value={selectedGroup}
                                                required={true}
                                            />
                                        </div>
                                    </div>

                                    {selectedGroup && (
                                        <div className="row align-items-center py-2  justify-content-center">
                                            <label className="col-sm-3 form-label require">Asset</label>
                                            <div className="col-sm-8">
                                                <InputAssetSearch
                                                    placeholder="Select Asset"
                                                    changeEvent={onAssetChange}
                                                    isClearable={true}
                                                    master_id={selectedGroup.value}
                                                    value={searchedAssetData}
                                                    required={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {
                                        formData.asset_id && (
                                            <>
                                                <div className="row  align-items-center py-2  justify-content-center">
                                                    <div className="col-md-3">
                                                        <label className="form-label ">Hour Applicable</label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="d-flex gap-3">
                                                            <div className="form-check">
                                                                <input
                                                                    id="y1"
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="hour_applicable"
                                                                    value="Y"
                                                                    checked={formData.hour_applicable === "Y"}
                                                                    onChange={handleRadioChange}
                                                                />
                                                                <label className="form-check-label" htmlFor="y1">Yes</label>
                                                            </div>

                                                            <div className="form-check">
                                                                <input
                                                                    id="n1"
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="hour_applicable"
                                                                    value="N"
                                                                    checked={formData.hour_applicable === "N"}
                                                                    onChange={handleRadioChange}
                                                                />
                                                                <label className="form-check-label" htmlFor="n1">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row align-items-center py-2  justify-content-center ">
                                                    <div className="col-md-3">
                                                        <label className="form-label ">Odo Meter Applicable</label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="d-flex gap-3">

                                                            <div className="form-check">
                                                                <input
                                                                    id="y2"
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="odo_meter_applicable"
                                                                    value="Y"
                                                                    checked={formData.odo_meter_applicable === "Y"}
                                                                    onChange={handleRadioChange}
                                                                />
                                                                <label className="form-check-label" htmlFor="y2">Yes</label>
                                                            </div>

                                                            <div className="form-check">
                                                                <input
                                                                    id="n2"
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="odo_meter_applicable"
                                                                    value="N"
                                                                    checked={formData.odo_meter_applicable === "N"}
                                                                    onChange={handleRadioChange}
                                                                />
                                                                <label className="form-check-label" htmlFor="n2">No</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row  align-items-center py-2  justify-content-center">
                                                    <div className="col-md-3">
                                                        <label className="form-label " >Movable</label>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="d-flex gap-3">

                                                            <div className="form-check">
                                                                <input
                                                                    id="y3"
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="movable"
                                                                    value="Y"
                                                                    checked={formData.movable === "Y"}
                                                                    onChange={handleRadioChange}
                                                                />
                                                                <label className="form-check-label" htmlFor="y3">Yes</label>
                                                            </div>

                                                            <div className="form-check">
                                                                <input
                                                                    id="n3"
                                                                    className="form-check-input"
                                                                    type="radio"
                                                                    name="movable"
                                                                    value="N"
                                                                    checked={formData.movable === "N"}
                                                                    onChange={handleRadioChange}
                                                                />
                                                                <label className="form-check-label" htmlFor="n3">No</label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </>
                                        )
                                    }

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={searchModalClose} data-bs-dismiss="modal">Close</button>
                                    <button type="submit" className="btn btn-primary mx-2" disabled={submitLoading}>
                                        Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default AssetLinkingWithDevice;
